import { instantDateKeyOf } from "./schedule";
import type { DiaryCategory } from "./types";

/** お題選択画面でカテゴリを並べる順。一次情報はここだけに置く */
export const DIARY_CATEGORIES: { value: DiaryCategory; label: string }[] = [
  { value: "love", label: "恋愛" },
  { value: "daily", label: "日常" },
  { value: "future", label: "将来" },
  { value: "memories", label: "思い出" },
  { value: "gratitude", label: "感謝" },
  { value: "whatif", label: "もしも" },
  { value: "life", label: "暮らし" },
  { value: "quiz", label: "クイズ" },
];

export function diaryCategoryLabelOf(category: DiaryCategory): string {
  return DIARY_CATEGORIES.find((c) => c.value === category)?.label ?? category;
}

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * 二人が交換日記を書き続けている日数。どちらか一方の投稿でもその日は継続扱いにする
 * (「今日はまだ」だけで途切れさせると、片方が忙しい日に消えてしまうため)。
 * 今日ぶんがまだ無くても、前日までの連続があれば0にはしない
 * (Shell.tsx の未執筆リマインダーと同じ「日境界の扱い」)。
 */
export function diaryStreakOf(
  entries: { createdAt: string }[],
  now = new Date().toISOString(),
): number {
  const dateKeys = new Set(entries.map((entry) => instantDateKeyOf(entry.createdAt)));
  let cursorMs = new Date(now).getTime();
  if (!dateKeys.has(instantDateKeyOf(new Date(cursorMs).toISOString()))) {
    cursorMs -= DAY_MS;
  }
  let streak = 0;
  while (dateKeys.has(instantDateKeyOf(new Date(cursorMs).toISOString()))) {
    streak++;
    cursorMs -= DAY_MS;
  }
  return streak;
}
